import { useState } from 'react';

import { DialogButton } from '@ui/uikit/components/common/Dialog';

import { PredictionDirection } from '../../../../../../../model/PredictionDirection';
import { MakePredictionModal } from '../../modals/MakePredictionModal/MakePredictionModal';
import type { PredictionButtonProps } from './ButtonProps';

export const ActivePredictionButton = ({ round, participation }: PredictionButtonProps) => {
  const [defaultDirection, setDefaultDirection] = useState(PredictionDirection.UP);
  const [isOpened, setIsOpened] = useState(false);

  const onClickPredictButton = (direction: PredictionDirection) => {
    setDefaultDirection(direction);
    setIsOpened(true);
  };

  return (
    <>
      {isOpened && (
        <MakePredictionModal
          defaultDirection={defaultDirection}
          open={isOpened}
          closeModal={() => setIsOpened(false)}
          round={round}
          onOpenChange={setIsOpened}
          participation={participation}
        />
      )}
      {participation.isParticipated ? (
        <DialogButton onClick={() => onClickPredictButton(participation.direction)}>
          More on {participation.direction}
        </DialogButton>
      ) : (
        <div className="flex w-full gap-2">
          <DialogButton onClick={() => onClickPredictButton(PredictionDirection.UP)}>
            Enter UP
          </DialogButton>
          <DialogButton onClick={() => onClickPredictButton(PredictionDirection.DOWN)}>
            Enter Down
          </DialogButton>
        </div>
      )}
    </>
  );
};
